import React from 'react'
import { theme } from '@/styles/theme'
interface ProfileIconProps extends React.SVGProps<SVGSVGElement> {
  active?: boolean
}

const ProfileIcon: React.FC<ProfileIconProps> = ({ active, ...props }) => (
  <svg
    width="37"
    height="36"
    viewBox="0 0 37 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M25.7182 12.913C25.7182 9.16711 22.6816 6.13043 18.9356 6.13043C15.1897 6.13043 12.153 9.16711 12.153 12.913C12.153 14.3366 12.5925 15.6572 13.342 16.7481C11.3143 17.6066 9.89215 19.616 9.89215 21.9565V28.7391C9.89215 29.3635 10.3983 29.8696 11.0226 29.8696H26.8487C27.473 29.8696 27.9791 29.3635 27.9791 28.7391V21.9565C27.9791 19.6156 26.5564 17.6064 24.5282 16.7481C25.2778 15.6571 25.7182 14.3369 25.7182 12.913ZM26.8487 12.913C26.8487 14.1279 26.5726 15.2789 26.0825 16.3077C27.9062 17.5227 29.1095 19.5984 29.1095 21.9565V28.7391C29.1095 29.9878 28.0973 31 26.8487 31H11.0226C9.85185 31 8.88946 30.1101 8.77386 28.9699L8.76172 28.7391V21.9565C8.76172 19.5989 9.96436 17.523 11.7876 16.3077C11.2978 15.2786 11.0226 14.1274 11.0226 12.913C11.0226 8.54279 14.5654 5 18.9356 5C23.3059 5 26.8487 8.54279 26.8487 12.913Z"
      fill={active ? theme.palette.primary[400] : theme.palette.gray[400]}
    />
    <circle
      cx="18.9358"
      cy="12.9129"
      r="4.52174"
      fill={active ? theme.palette.primary[400] : theme.palette.gray[400]}
    />
    <path
      d="M12.1533 22.5659C12.1533 20.3568 13.9442 18.5659 16.1533 18.5659H21.7185C23.9277 18.5659 25.7185 20.3568 25.7185 22.5659V26.6094C25.7185 27.1617 25.2708 27.6094 24.7185 27.6094H13.1533C12.601 27.6094 12.1533 27.1617 12.1533 26.6094V22.5659Z"
      fill={active ? theme.palette.primary[400] : theme.palette.gray[400]}
    />
  </svg>
)

export default ProfileIcon
